module.exports = __webpack_public_path__ + "static/media/cheers_icon.1baa992c.png";